module.exports = __webpack_public_path__ + "assets/feature2-f06488eedd73692d14a4e9c74d90f5d7.svg";